import { AxiosInstance, AxiosResponse } from 'axios';

import { ApiResponse } from '@src/types/api/response/api-response';

type GetLoginInfoDto = {
  email: string;
};

export type GetLoginInfoResponseDto =
  | {
      action: 'requires-social-login';
      provider: string;
    }
  | {
      action: 'login';
    }
  | {
      action: 'signup';
    };

export class ProfileInfoService {
  constructor(private readonly networkService: AxiosInstance) {}

  async getLoginInfo(email: string) {
    const { data } = await this.networkService.post<
      GetLoginInfoDto,
      AxiosResponse<ApiResponse<GetLoginInfoResponseDto>>
    >('/profile/v1/login-info', {
      email,
    });
    return data.data;
  }
}
